import React from 'react';
import MultiFilterInput, { FILTER_PREFIXES } from "../../../Components/Inputs/MultiFilterInput";
import { prefixFormOptions } from "../../../Helpers/FormHelper";
import { useSelector } from "react-redux";

const BookingsMultiFilter = (props) => {

    const currentUser = useSelector(state => state.global.currentUser);

    const getFilterOptions = () => {
        let filterOptions = [];

        // Only add block filter options if multiple blocks are available
        if (currentUser && currentUser.blocks?.length > 1) {
            let blockOptions = currentUser.blocks.map(block => {
                return {
                    value: block.id,
                    label: block.name
                }
            });

            filterOptions.push({
                label: 'Blocks',
                options: prefixFormOptions(blockOptions, FILTER_PREFIXES.BLOCK)
            });
        }

        return filterOptions;
    }

    return (
        <MultiFilterInput
            value={props.value}
            options={getFilterOptions()}
            onChange={props.onChange}
        />
    )
}

export default BookingsMultiFilter;
